module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": _vm.isLoaded,
      "caption": _vm.isLoaded ? 'Показать ' + this.topCount : 'Еще',
      "expandable": !((_vm.totalPages == _vm.loadedPages) && (this.topCount > this.items.length))
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading && _vm.loadedPages < 0),
      expression: "isLoading && loadedPages < 0"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.isLoading && _vm.loadedPages == 0)),
      expression: "!(isLoading && loadedPages == 0)"
    }]
  }, [_c('v-items-field', {
    attrs: {
      "items": _vm.getScheduledActions(),
      "smallIcons": ""
    },
    on: {
      "click": function($event) {
        return _vm.onActionClick($event)
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3408b831","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/ActionLogsPanel.vue
// module id = 994
// module chunks = 1